const WM_FLOATING_ELEVATION_CLASSNAME = 'tw-shadow-md';
const WM_FLAT_SURFACE_CLASSNAME = 'tw-border tw-border-border tw-bg-background tw-text-foreground tw-shadow-none';
const WM_MUTED_SURFACE_CLASSNAME = 'tw-border tw-border-border tw-bg-accent tw-text-foreground tw-shadow-none';
const WM_FLOATING_SURFACE_CLASSNAME = `tw-border tw-border-border tw-bg-background tw-text-foreground ${WM_FLOATING_ELEVATION_CLASSNAME}`;

export {
    WM_FLOATING_ELEVATION_CLASSNAME,
    WM_FLAT_SURFACE_CLASSNAME,
    WM_FLOATING_SURFACE_CLASSNAME,
    WM_MUTED_SURFACE_CLASSNAME
};
